import { Action, Dispatch } from 'redux';

import { IAppState } from './reducers';
import { queryGamesAction } from './search';
import { queryGames } from './exchange/searchResults';
import { SelectionModel } from '../cdk/selection';
import {
  terminateLiveStream as terminateLiveStreamApi,
  IDeleteParams, deleteAssets,
} from '../api/vault/assets';
import { AssetHit } from '../api/vault/searchEngine/interfaces';
import { Routes } from '../constants';

const refreshTimeout = 3500;

export interface IState {
  isDeleteButtonClicked: boolean,
  selectedAssets: AssetHit[],
  areAssetsDeleted: boolean,
  resetAssetsSelected: boolean,
  errorInDelete: boolean,
  assetSelection: SelectionModel<AssetHit>
}

export enum ActionType {
  DeleteButtonClicked = 'DeleteAssets.DeleteClicked',
  DeleteSelectedAssets = 'DeleteAssets.delete',
}
export interface IDeleteAssets extends Action<ActionType> {
  payload: any
}

export const INITIAL_STATE: IState = {
  isDeleteButtonClicked: false,
  areAssetsDeleted: false,
  selectedAssets: [],
  resetAssetsSelected: false,
  errorInDelete: false,
  assetSelection: new SelectionModel<AssetHit>(),
};

export default function reducer(state: IState = INITIAL_STATE, action: IDeleteAssets): IState {
  switch (action.type) {
    case ActionType.DeleteSelectedAssets:
    case ActionType.DeleteButtonClicked:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const toggleDeleteAssets = (isDeleteButtonClicked: boolean, selectedAssets: any) => async (dispatch: Dispatch<IDeleteAssets>) => {
  try {
    dispatch({
      payload: {
        isDeleteButtonClicked,
        selectedAssets,
      },
      type: ActionType.DeleteButtonClicked,
    });
  } catch (e) {
    dispatch({
      payload: {
        errorInDelete: true,
      },
      type: ActionType.DeleteButtonClicked,
    });
  }
};

export const deleteSelectedAssets = (deleteParams: IDeleteParams, refreshSearch: boolean = false, callback?: () => void) => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const response = await deleteAssets(deleteParams);
  if (response.status === 200) {
    dispatch({
      payload: {
        areAssetsDeleted: true,
        isDeleteButtonClicked: false,
        selectedAssets: [],
      },
      type: ActionType.DeleteSelectedAssets,
    });
    if (refreshSearch) {
      const {
        location: {
          pathname: route,
        },
      } = window;
      if (route === Routes.HOME) {
        queryGamesAction(refreshTimeout)(dispatch, getState);
      } else if (route === Routes.EXCHANGE) {
        queryGames(refreshTimeout)(dispatch, getState);
      }
    }
    if (callback) callback();
  } else {
    dispatch({
      payload: {
        areAssetsDeleted: false,
      },
      type: ActionType.DeleteSelectedAssets,
    });
  }
};

export const terminateLiveStream = (id: string, callback?: () => void) => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const terminateResponse = await terminateLiveStreamApi(id);
  const deleteResponse = await deleteAssets({ ids: [id] } as any);
  if (callback) setTimeout(() => { callback(); }, 250);
  if (deleteResponse.status === 200) {
    dispatch({
      payload: {
        areAssetsDeleted: true,
        isDeleteButtonClicked: false,
        selectedAssets: [],
      },
      type: ActionType.DeleteSelectedAssets,
    });
  } else {
    dispatch({
      payload: {
        areAssetsDeleted: false,
      },
      type: ActionType.DeleteSelectedAssets,
    });
  }
};
